class FaqAccordion extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.faq-item'));
    this.sidebar = this.querySelector('.faq-sidebar');
    this.sidebarWrap = this.querySelector('.faq-sidebar-wrap');
    this.sidebarButtons = Array.from(this.querySelectorAll('.faq-sidebar__item'));
    this.searchInput = this.querySelector('[data-faq-search]');
    this.emptyState = this.querySelector('[data-faq-empty]');
    this.activeCategory = 'all';

    this.items.forEach((details) => {
      const summary = details.querySelector('summary');
      summary.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleItem(details);
      });
    });

    this.sidebarButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (this.searchInput) this.searchInput.value = '';
        this.sidebarButtons.forEach((btn) => btn.classList.remove('is-active'));
        button.classList.add('is-active');
        this.activeCategory = button.getAttribute('data-category-filter');
        this.filterList();
        button.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
    });

    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => {
        const isSearching = this.searchInput.value.trim().length > 0;
        this.sidebarButtons.forEach((btn) => {
          const filter = btn.getAttribute('data-category-filter');
          btn.classList.toggle('is-active', isSearching ? filter === 'all' : filter === this.activeCategory);
        });
        this.filterList();
      });
    }

    if (this.sidebar && this.sidebarWrap) {
      this.updateSidebarFade();
      this.sidebar.addEventListener('scroll', () => this.updateSidebarFade(), { passive: true });
      window.addEventListener('resize', () => this.updateSidebarFade());
    }
  }

  updateSidebarFade() {
    const { scrollLeft, scrollWidth, clientWidth } = this.sidebar;
    const maxScroll = scrollWidth - clientWidth;
    this.sidebarWrap.classList.toggle('has-fade-start', scrollLeft > 4);
    this.sidebarWrap.classList.toggle('has-fade-end', scrollLeft < maxScroll - 4);
  }

  toggleItem(details) {
    if (details.classList.contains('is-animating')) return;
    if (details.open) {
      this.collapse(details);
    } else {
      this.expand(details);
    }
  }

  expand(details) {
    details.style.height = `${details.offsetHeight}px`;
    details.open = true;
    requestAnimationFrame(() => this.runAnimation(details, true));
  }

  collapse(details) {
    details.style.height = `${details.offsetHeight}px`;
    requestAnimationFrame(() => this.runAnimation(details, false));
  }

  runAnimation(details, isExpanding) {
    details.classList.add('is-animating');
    const startHeight = details.offsetHeight;
    const summaryHeight = details.querySelector('summary').offsetHeight;
    const contentHeight = details.querySelector('.faq-item__answer-wrap').offsetHeight;
    const endHeight = isExpanding ? summaryHeight + contentHeight : summaryHeight;

    if (details.faqAnimation) {
      details.faqAnimation.cancel();
    }

    if (!details.animate) {
      details.style.height = '';
      details.open = isExpanding;
      details.classList.remove('is-animating');
      return;
    }

    details.faqAnimation = details.animate(
      { height: [`${startHeight}px`, `${endHeight}px`] },
      { duration: 250, easing: 'ease' }
    );

    details.faqAnimation.onfinish = () => {
      details.open = isExpanding;
      details.style.height = '';
      details.classList.remove('is-animating');
      details.faqAnimation = null;
    };

    details.faqAnimation.oncancel = () => {
      details.classList.remove('is-animating');
    };
  }

  filterList() {
    const search = this.searchInput ? this.searchInput.value.trim().toLowerCase() : '';
    let visibleCount = 0;

    this.items.forEach((item) => {
      const category = (item.getAttribute('data-category') || '').toLowerCase();
      const questionText = (item.getAttribute('data-question-text') || '').toLowerCase();
      const answerText = item.querySelector('.faq-item__answer').textContent.toLowerCase();

      const matchesSearch = !search || questionText.includes(search) || answerText.includes(search);
      const matchesCategory = search
        ? true
        : this.activeCategory === 'all' || category === this.activeCategory.toLowerCase();
      const visible = matchesCategory && matchesSearch;

      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    if (this.emptyState) {
      this.emptyState.hidden = visibleCount !== 0;
    }
  }
}

customElements.define('faq-accordion', FaqAccordion);
